// src/docs/components/DocsSidebar.tsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getDocList } from '../utils/docs';

interface DocsSidebarProps {
  tableOfContents?: React.ReactNode;
}

const DocsSidebar: React.FC<DocsSidebarProps> = ({ tableOfContents }) => {
  const location = useLocation();
  const selectedKey = location.pathname.split('/').pop() || 'Welcome';

  const docFiles = getDocList();

  // Simple grouping for now, can be enhanced later to parse frontmatter for categories
  const docsNav = [
    {
      title: 'Guide',
      key: 'guide',
      links: docFiles.map(name => ({
        href: `/docs/${name}`,
        label: name.replace(/-/g, ' ')
      }))
    },
  ];

  return (
    <aside className="h-full w-full">
      <div className="space-y-6">
        <div className="border border-neutral-950 dark:border-neutral-100">
          {docsNav.map((section, sectionIndex) => (
            <div key={section.key}>
              <div className="px-4 py-3 bg-neutral-950 text-neutral-50 dark:bg-neutral-100 dark:text-neutral-950 font-mono text-xs font-bold uppercase tracking-wider border-b border-neutral-950 dark:border-neutral-100 flex justify-between items-center">
                <span>{section.title}</span>
                <span className="opacity-50">0{sectionIndex + 1}</span>
              </div>
              <div className="divide-y divide-neutral-950 dark:divide-neutral-100 bg-background">
                {section.links.map((link, i) => {
                  const isActive = selectedKey === link.href.split('/').pop();
                  return (
                    <Link
                      to={link.href}
                      key={link.label}
                      className={`block px-4 py-3 text-sm font-mono transition-colors hover:bg-neutral-100 dark:hover:bg-neutral-800 ${
                        isActive
                          ? 'bg-neutral-100 dark:bg-neutral-800 font-bold text-foreground border-l-4 border-l-neutral-950 dark:border-l-neutral-100 -ml-[1px]'
                          : 'text-muted-foreground hover:text-foreground'
                      }`}
                    >
                      <div className="flex gap-3">
                        <span className="opacity-30 select-none">{(i + 1).toString().padStart(2, '0')}</span>
                        <span className="uppercase tracking-tight">{link.label}</span>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {tableOfContents && (
          <div className="border border-neutral-950 dark:border-neutral-100">
            <div className="px-4 py-3 bg-neutral-950 text-neutral-50 dark:bg-neutral-100 dark:text-neutral-950 font-mono text-xs font-bold uppercase tracking-wider border-b border-neutral-950 dark:border-neutral-100 flex justify-between items-center">
              <span>CONTENTS</span>
              <span className="opacity-50">02</span>
            </div>
            <div className="bg-background p-4">
              {tableOfContents}
            </div>
          </div>
        )}
      </div>
    </aside>
  );
};

export default DocsSidebar;
